import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { usePathname } from 'next/navigation'
import ExternalLinks from '@/(front-desk)/components/ExternalLinks'
import ActiveLink from '@/(front-desk)/components/ActiveLink'
import UserAvatar from '@/(front-desk)/components/UserAvatar'
import logo from '@/(front-desk)/assets/images/2024/logo.png'
import classNames from 'classnames'
import Link from 'next/link'

export default function Navbar() {

    const account = useSelector((state) => state.account)
    const pathname = usePathname()
    const [ dropMenu, setDropMenu ] = useState(false)
    const [ dropItem, setDropItem ] = useState(false)
    const navbarRef = useRef()
    const dropMenuRef = useRef()

    useEffect(() => {
        setDropMenu(false)
    }, [pathname])

    useEffect(() => {
        handleWindowResize()
        window.addEventListener('resize', handleWindowResize, null)

        return() => {
            window.removeEventListener('resize', handleWindowResize, null)
        }
    }, [dropMenu])

    function handleWindowResize() {
        if (dropMenuRef.current && navbarRef.current) {
            if (dropMenu) {
                document.body.style.overflow = 'hidden'
                dropMenuRef.current.style.height = `${window.innerHeight - navbarRef.current.offsetHeight}px`
            }
            else {
                document.body.style.overflow = 'auto'
            }
        }
    }

    const sectionLinksClass = classNames('section', 'section-links', {
        'active': dropMenu
    })
    const btnHamburgerClass = classNames('btn-hamburger', {
        'active': dropMenu
    })

    return (
        <>
        <div className="navbar" ref={navbarRef}>
            <div className={classNames('navbar-content', {
                'fade-in': account.data !== null
            })}>
                <div className="section section-logo">
                    <Link className="logo" href="/" title="返回首頁">
                        <img src={logo.src} alt="臺灣產學策進會放視大賞 Logo" />
                    </Link>
                </div>
                <div className={sectionLinksClass} ref={dropMenuRef}>
                    <div className="section-link-content flex">
                        {/* <ActiveLink href="/billboard">人氣作品投票</ActiveLink> */}
                        <ActiveLink href="/news/all">最新消息</ActiveLink>
                        <ActiveLink href="/about">關於放視</ActiveLink>
                        <ActiveLink href="/exhibit">報名參展</ActiveLink>
                        <ActiveLink href="/compete">報名競賽</ActiveLink>
                        <button
                            className={classNames('btn', 'btn-drop', {
                                'open': dropItem,
                                'active': pathname.startsWith('/information')
                            })}
                            onMouseOver={() => {setDropItem(true)}}
                            onMouseLeave={() => {setDropItem(false)}}
                        >
                            展覽資訊
                            <div className="drop-item-area">
                                <ActiveLink
                                    href="/information/about"
                                    onClick={() => {setDropItem(false)}}
                                    exact
                                >參觀資訊</ActiveLink>
                                <ActiveLink
                                    href="/information/transportation"
                                    onClick={() => {setDropItem(false)}}
                                    exact
                                >交通資訊</ActiveLink>
                                <ActiveLink
                                    href="/information/activities"
                                    onClick={() => {setDropItem(false)}}
                                    exact
                                >展覽活動資訊</ActiveLink>
                                <ActiveLink
                                    href="/information/time-table"
                                    onClick={() => {setDropItem(false)}}
                                    exact
                                >活動時間表</ActiveLink>
                            </div>
                        </button>
                        <ActiveLink href="/download/procedure">下載專區</ActiveLink>
                        {/* <ActiveLink href="/career-matching">找工作專區</ActiveLink> */}
                        { account.data
                            ?
                            <Link href="/user/account/information" className="">
                                <UserAvatar
                                    avatar={account.data.avatar}
                                    screenName={account.data.screen_name}
                                />
                            </Link>
                            :
                            <Link className="btn btn-login hidden min-[1165px]:block" href="/user/login">登入</Link>
                        }
                    </div>
                    <div className="icon-area drop-only">
                        <div className="title">Follow Us</div>
                        <div className="icon-group">
                            <ExternalLinks />
                        </div>
                    </div>
                </div>
                {/* <div className="flex items-center lg:hidden"> */}
                <div className="flex items-center min-[1165px]:hidden">
                
                        { account.data
                            ?
                            <Link href="/user/account/information">
                                <UserAvatar
                                    avatar={account.data.avatar}
                                    screenName={account.data.screen_name}
                                />
                            </Link>
                            :
                            <Link className="btn btn-login" href="/user/login">登入</Link>
                        }
                    <button
                        className={btnHamburgerClass}
                        onClick={() => {setDropMenu(!dropMenu)}}
                        aria-label="網頁選單按鈕"
                    ><div></div></button>
                </div>
            </div>
        </div>
        </>
    )
}
